import { useTranslation } from 'react-i18next';
import { Md } from '../components/Md';

export default function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-3xl px-6 py-20 md:py-28">
      <h1 className="font-display text-3xl font-bold tracking-tight md:text-4xl">{t('privacy.heading')}</h1>

      <div className="mt-10 space-y-10 text-slate-300 text-sm leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('privacy.section1.heading')}</h2>
          <p className="mt-3">{t('privacy.section1.p1')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('privacy.section2.heading')}</h2>
          <p className="mt-3">{t('privacy.section2.p1')}</p>
          <ul className="mt-3 list-disc pl-5 space-y-2">
            <li><Md>{t('privacy.section2.accountInfo')}</Md></li>
            <li><Md>{t('privacy.section2.translationData')}</Md></li>
            <li><Md>{t('privacy.section2.apiKeys')}</Md></li>
            <li><Md>{t('privacy.section2.usageData')}</Md></li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('privacy.section3.heading')}</h2>
          <p className="mt-3">{t('privacy.section3.p1')}</p>
          <ul className="mt-3 list-disc pl-5 space-y-2">
            {(t('privacy.section3.items') as unknown as string[]).map((item, i) => (
              <li key={i}><Md>{item}</Md></li>
            ))}
          </ul>
          <p className="mt-3">{t('privacy.section3.p2')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('privacy.section4.heading')}</h2>
          <p className="mt-3">{t('privacy.section4.p1')}</p>
          <p className="mt-3">{t('privacy.section4.p2')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('privacy.section5.heading')}</h2>
          <p className="mt-3">{t('privacy.section5.p1')}</p>
          <ul className="mt-3 list-disc pl-5 space-y-2">
            <li><Md>{t('privacy.section5.paddle')}</Md></li>
            <li><Md>{t('privacy.section5.sentry')}</Md></li>
            <li><Md>{t('privacy.section5.anthropic')}</Md></li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('privacy.section6.heading')}</h2>
          <p className="mt-3">{t('privacy.section6.p1')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('privacy.section7.heading')}</h2>
          <p className="mt-3">{t('privacy.section7.p1')}</p>
          <ul className="mt-3 list-disc pl-5 space-y-2">
            {(t('privacy.section7.items') as unknown as string[]).map((item, i) => (
              <li key={i}><Md>{item}</Md></li>
            ))}
          </ul>
          <p className="mt-3"><Md>{t('privacy.section7.p2')}</Md></p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('privacy.section8.heading')}</h2>
          <p className="mt-3">{t('privacy.section8.p1')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('privacy.section9.heading')}</h2>
          <p className="mt-3">{t('privacy.section9.p1')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-100">{t('privacy.section10.heading')}</h2>
          <p className="mt-3"><Md>{t('privacy.section10.p1')}</Md></p>
        </section>
      </div>
    </div>
  );
}
